export default "__VITE_ASSET__828ecde2__"